import { white } from '../colors';
export var MuiMenuItem = {
    styleOverrides: {
        root: {
            '&[class*=Mui-selected]': { color: white },
        },
    },
};
